var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"miner-status-container",style:(_vm.stateStyle)},[_c('div',{staticClass:"miner-status-content d-flex align-center"},[_c('span',[_vm._v(_vm._s(_vm.statusText(_vm.status)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }